export const PETS_FIRESTORE_DOC = "playerPets";

export const PET_CREATE_CARD_SKU = "character.pet_create_card.v1";
export const PET_CREATE_CARD_CASH_COST = 2_000;

export const PET_AP_CARD_SKU = "character.pet_ap_card.v1";
export const PET_AP_CARD_CASH_COST = 10;

export const PET_SIZE_CARD_SKU = "character.pet_size_card.v1";
export const PET_SIZE_CARD_CASH_COST = 50;
/** Display scale +1% per size card applied to a pet. */
export const PET_SIZE_PERCENT_PER_CARD = 1;

export const PET_BASE_AP = 20;
export const PET_AP_PER_CARD = 2;

export const PET_SKILL_CREATE_CARD_SKU = "pet.skill_create_card.v1";
export const PET_SKILL_CREATE_CARD_CASH_COST = 250;

export const PET_SKILL_COOLDOWN_CARD_SKU = "pet.skill_cooldown_card.v1";
export const PET_SKILL_COOLDOWN_CARD_CASH_COST = 200;

export const PET_SKILL_AP_CARD_SKU = "pet.skill_ap_card.v1";
export const PET_SKILL_AP_CARD_CASH_COST = 50;

export const PET_SKILL_BUFF_DURATION_CARD_SKU = "pet.skill_buff_duration_card.v1";
export const PET_SKILL_BUFF_DURATION_CARD_CASH_COST = 50;

export const PET_SKILL_AOE_RANGE_CARD_SKU = "pet.skill_aoe_range_card.v1";
export const PET_SKILL_AOE_RANGE_CARD_CASH_COST = 50;

export const PET_DISPLAY_ALPHA = 1;
export const PET_SCALE_MULTIPLIER = 1;
/** Behind player and behind equipped shadow overlay (shadow uses −2). */
export const PET_DEPTH_BEHIND = 3;

/** Horizontal offset so pet sits beside the player’s back (opposite facing). */
export const PET_FOLLOW_OFFSET_X = 52;
/** Slight upward shift so the pet peeks out from behind the player sprite. */
export const PET_FOLLOW_OFFSET_Y = 14;
export const PET_FOLLOW_LERP = 0.14;
export const PET_ATTACK_RANGE = 72;
export const PET_SKILL_RANGE = 96;
